// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607070022/js/" + chunkId + "." + {"44":"7b6d384a","225":"57abb8aa","481":"1b1b7e31","486":"c83570be","770":"f31f4fa6"}[chunkId] + ".0.4002203145461588.chunk.js";
};